// extracted by mini-css-extract-plugin
module.exports = {"root":"BrandName_root__3Sqwy","header-label":"BrandName_header-label__2vXlg"};